export { EmailPending } from './EmailPending';
export { EmailConfirmation } from '../../containers/handlers'
export { Download } from './Download';
export { Landing } from './Landing';
export { LanguageList } from './LanguageList';
export { PlanSubscription } from './PlanSubscription';
export { TermsOfService } from './TermsOfService';
export { AccountSettings } from './AccountSettings';
export { TestThemeView } from './TestTheme'



// WEBPACK FOOTER //
// ./src/components/presentational/views/index.ts